export enum TimeOfDay {
    Anytime = 'Anytime',
    Morning = 'Morning',
    Afternoon = 'Afternoon',
    Evening = 'Evening',
}
